import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from 'react';
import { portalId } from '../../constants/leadinConfig';
import ElementorBanner from '../Common/ElementorBanner';
import { fetchForms } from '../../api/hubspotApiClient';
import UISpinner from '../../shared/UIComponents/UISpinner';
import { __ } from '@wordpress/i18n';
const mapForm = (form) => ({
    label: form.name,
    value: form.guid,
});
export default function ElementorFormSelect({ formId, setAttributes, }) {
    const [loading, setLoading] = useState(false);
    const [hasError, setError] = useState(null);
    const [forms, setForms] = useState([]);
    useEffect(() => {
        setLoading(true);
        fetchForms('', 0, 100)
            .then(data => {
            setForms(data.map(mapForm));
        })
            .catch(error => setError(error))
            .finally(() => setLoading(false));
    }, [setForms]);
    return (_jsx(Fragment, { children: loading ? (_jsx("div", { children: _jsx(UISpinner, {}) })) : hasError ? (_jsx(ElementorBanner, { type: "danger", children: __('Please refresh your forms or try again in a few minutes.', 'leadin') })) : (_jsxs("select", { value: formId, onChange: event => {
                const selectedForm = forms.find(form => form.value === event.target.value);
                if (selectedForm) {
                    setAttributes({
                        portalId,
                        formId: selectedForm.value,
                        formName: selectedForm.label,
                    });
                }
            }, children: [_jsx("option", { value: "", disabled: true, selected: true, children: __('Search for a form', 'leadin') }), forms.map(form => (_jsx("option", { value: form.value, children: form.label }, form.value)))] })) }));
}
